import { createReducer } from '@reduxjs/toolkit';
import {
  addAssignedChannels,
  adminCreateGroupChannel,
  setChatSearchText,
  createChatFromPharmacy,
  createChatFromProfessional,
  createGroupChannel,
  logout,
  resetChatValues,
  setChannelMetaData,
  setChatActiveTab,
  setChatTabUnreadCount,
  setCreatedChannelProperties,
  setSelectedClient,
  setUnreadCount,
  setEnteredChannelUrl,
  setClientTabUnreadCount,
} from '../actions';
import {
  IAdminCreatedChannelProperties,
  IChatTabUnreadCount,
  IClientTabUnreadCount,
} from '../models/ChatModels';
import { ClientChatTypes, IChannelData } from '../helpers/Constants';

export interface IChatReducerState {
  searchedText: string;
  enteredChannelUrl: string;
  activeTab: ClientChatTypes | string;
  channelUrl: string;
  pharmacyChannelUrl: string;
  professionalChannelUrl: string;
  adminChannelUrl: string;
  assignedChannels: Array<string>;
  userUnreadCount: number;
  selectedClient: string;
  channelProperties: IAdminCreatedChannelProperties;
  channelMetaData: IChannelData;
  unreadTabCount: IChatTabUnreadCount;
  clientUnreadTabCount: IClientTabUnreadCount;
}

export const chatInitialState: IChatReducerState = {
  clientUnreadTabCount: {},
  searchedText: '',
  enteredChannelUrl: '',
  unreadTabCount: {},
  pharmacyChannelUrl: '',
  professionalChannelUrl: '',
  activeTab: '',
  channelMetaData: {},
  channelUrl: '',
  adminChannelUrl: '',
  assignedChannels: [],
  userUnreadCount: 0,
  selectedClient: '',
  channelProperties: {
    channelName: '',
    userType: '',
    personnelId: '',
  },
};

const chatReducer = createReducer(chatInitialState, (builder) =>
  builder
    .addCase(createGroupChannel.fulfilled, (state, action) => {
      state.channelUrl = action.payload;
    })
    .addCase(createChatFromPharmacy.fulfilled, (state, action) => {
      state.pharmacyChannelUrl = action.payload;
    })
    .addCase(createChatFromProfessional.fulfilled, (state, action) => {
      state.professionalChannelUrl = action.payload;
    })
    .addCase(addAssignedChannels, (state, action) => {
      state.assignedChannels = action.payload;
    })
    .addCase(setUnreadCount, (state, action) => {
      state.userUnreadCount = action.payload;
    })
    .addCase(setSelectedClient, (state, action) => {
      state.selectedClient = action.payload;
    })
    .addCase(setCreatedChannelProperties, (state, action) => {
      state.channelProperties = action.payload;
    })
    .addCase(adminCreateGroupChannel.fulfilled, (state, action) => {
      state.adminChannelUrl = action.payload;
    })
    .addCase(setChannelMetaData, (state, action) => {
      state.channelMetaData = action.payload;
    })
    .addCase(setChatActiveTab, (state, action) => {
      state.activeTab = action.payload;
    })
    .addCase(setChatTabUnreadCount, (state, action) => {
      state.unreadTabCount = action.payload;
    })
    .addCase(setClientTabUnreadCount, (state, action) => {
      state.clientUnreadTabCount = action.payload;
    })
    .addCase(setChatSearchText, (state, action) => {
      state.searchedText = action.payload;
    })
    .addCase(setEnteredChannelUrl, (state, action) => {
      state.enteredChannelUrl = action.payload;
    })
    .addCase(resetChatValues, (state, action) => {
      action.payload.map(
        (item) =>
          // @ts-expect-error: REDUCERS HAVE WRITABLE INNATE TYPE
          (state[item] =
            chatInitialState[item as keyof typeof chatInitialState])
      );
    })
    .addCase(logout.fulfilled, (state, action) => {
      return chatInitialState;
    })
);

export default chatReducer;
